module.exports = __webpack_public_path__ + "static/media/leandro-vieira.de04e26e.png";